import React, { useEffect, useState } from 'react';

import classNames from 'classnames';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Select from 'react-select';
import { Card, CardBody, Container, Nav, NavItem, NavLink, Row, TabContent, TabPane } from 'reactstrap';
import { GET_CARD_SUMMARY, GET_DASHBOARD_CONFIGURATION } from '../../../../store/actions';
import { DonutChart, GeoChart, Loader } from '../../../Common';
import BreadcrumbTrail from '../../../Common/BreadcrumbTrail';
import DownloadModal from './Components/Modals/DownloadModal';
import StatusCard from './Components/Cards/StatusCard/StatusCard';
import TimeSlot from './Components/TimeSlot/TimeSlot';
import DelayedBookingChart from '../../../Common/Chart/BarChartV2';
import { Constant } from '../../../Helpers/constant';
import { get } from 'lodash';
import CommanDashboard from './Components/CommanDashboard';
import AirportDashboard from './Components/AirportDashboard';
import GolfDashboard from './Components/GolfDashboard';

const VendorDashboardV2: React.FC = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  const { getDashboardConfiguration, getDashboardConfigurationLoading } = useSelector((state: RootState) => ({
    getDashboardConfiguration: state.GetDashboardConfiguration.data,
    getDashboardConfigurationLoading: state.GetDashboardConfiguration.loading,
  }));

  const [isDashboardType, setIsDashboardType] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (getDashboardConfiguration !== null) {
      const modules = getDashboardConfiguration?.modules || {};
      const onlyModuleKey = Object.keys(modules);
      if (onlyModuleKey && onlyModuleKey.includes('golf_vendor_main_dashboard')) {
        setIsDashboardType('golf');
      } else {
        setIsDashboardType('airport_transfer');
      }
    }
  }, [getDashboardConfiguration]);

  useEffect(() => {
    dispatch({
      type: GET_DASHBOARD_CONFIGURATION,
    });
  }, []);

  useEffect(() => {
    const userTypes = Number(localStorage.getItem('userType'));
    if (userTypes === Constant.userTypes.ADMIN_USER_V2) {
      history.push('/v2/dashboard');
    } else if (userTypes === Constant.userTypes.ADMIN_USER) {
      history.push('/login');
    }
  }, []);

  useEffect(() => {
    if (getDashboardConfigurationLoading) {
      setLoading(true);
    } else {
      setLoading(false);
    }
  }, [getDashboardConfigurationLoading]);

  return (
    <>
      {loading && <Loader />}

      {isDashboardType === 'airport_transfer' && <AirportDashboard />}
      {isDashboardType === 'golf' && <GolfDashboard />}
    </>
  );
};

export default VendorDashboardV2;
